import Confirm from './confirm'

export type { ConfirmProps } from './confirm-types'

export default Confirm
